import { Route, Routes, useLocation, useNavigate, Navigate } from "react-router-dom";
import NavigationTabs from "../distributor-settings/network-access/navigation-tabs";
import { useCallback, useMemo } from "react";
import Header from "./Header";
import { APP_ROUTES, ROUTE_PATHS } from "../../constants/app.constants";
import SubscriptionsPage from "../hg-settings/subscriptions";
import styles from "./hg-settings-wrapper.module.scss";
import TagsPage from "../distributor-settings/tags";
import MembersAccessPage from "../hg-settings/members-access";
import StatusesPage from "../hg-settings/statuses";
import NetworkAccessPage from "../distributor-settings/network-access";

const HgSettingsRoutes = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname;

  const leftSideComponent = (
    <div className="ml-4 d-flex align-items-center">
      <h3 className="m-0 f-14 line-height-22">HG Settings</h3>
    </div>
  )
  
  const onTabClick = useCallback((route) => {
    if (route) {
      navigate(route, { state: location.state });
    }
  }, [navigate, location.state]);

  const navigationTabs = useMemo(() => [
    { label: "Subscriptions", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.subscriptions, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.subscriptions, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.subscriptions) },
    { label: "Tags", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.tags, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.tags, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.tags) },
    { label: "Statuses", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.statuses, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.statuses, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.statuses) },
    { label: "Members and Access", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.membersAndAccess, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.membersAndAccess, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.membersAndAccess) },
    { label: "Network Access", active: currentPath === ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.networkAccess, disabled: false, route: ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.networkAccess, onClick: () => onTabClick(ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.networkAccess) },
  ], [currentPath, onTabClick]);
  
  return (
    <div id="body-container-id" className="body-container hide-scrollbar">
      <Header isLoading={false} accountId={undefined} data={undefined} leftSideComponent={leftSideComponent} />
      <div className={styles.container}>
        <div className="nab-tabs-container p-0">
          <NavigationTabs tabs={navigationTabs} />
        </div>
        <Routes>
          <Route path={APP_ROUTES.subscriptionPortalPages.hgSettingsPages.subscriptions} element={<SubscriptionsPage />} />
          {/* <Route path="tags" element={<TagsPage />} /> */}
          <Route
            path={APP_ROUTES.subscriptionPortalPages.hgSettingsPages.tags}
            element={<TagsPage />}
          />
          <Route path={APP_ROUTES.subscriptionPortalPages.hgSettingsPages.statuses} element={<StatusesPage />} />
          <Route path={APP_ROUTES.subscriptionPortalPages.hgSettingsPages.membersAndAccess} element={<MembersAccessPage />} />
          <Route path={APP_ROUTES.subscriptionPortalPages.hgSettingsPages.networkAccess} element={<NetworkAccessPage />} />
          <Route path="" element={<Navigate to={ROUTE_PATHS.subscriptionPortalPages.hgSettingsPages.subscriptions} replace />} />
          <Route path="*" element={<Navigate to={ROUTE_PATHS.subscriptionPortalPages.overview} replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default HgSettingsRoutes;
